/**
 * /operations/comp-agent — Comp Management agent (Pack 13 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function CompMgmtAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Comp Management Agent"
        subtitle="Tashghil schedules cycles + drives reviews; Rawatib posts adjustments."
      />
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="tashghil" /><h3 className="text-base font-semibold">Tashghil — comp cycles</h3></div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li>Annual review cycle scheduling per LE</li>
          <li>Quarterly bonus cycle</li>
          <li>Monthly commission processing</li>
          <li>Off-cycle promotion routing</li>
          <li>Market adjustment workflow</li>
        </ul>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="rawatib" /><h3 className="text-base font-semibold">Rawatib — posts</h3></div>
        <p className="text-sm text-text-secondary">Posts adjustments via the retro engine. Computes new gross + reschedules deductions.</p>
      </section>
    </div>
  );
}
